import React, { useEffect, useRef, useState } from "react"
import { CircularProgress, Grid, Typography } from "@mui/material"
import api from "../../services/api"

const POWERBI_SDK_URL = "https://cdn.jsdelivr.net/npm/powerbi-client@2.23.1/dist/powerbi.min.js"

const loadPowerBiSdk = () => {
    if (window.powerbi && window["powerbi-client"]) {
        return Promise.resolve()
    }

    return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${POWERBI_SDK_URL}"]`)

        if (existingScript) {
            existingScript.addEventListener("load", resolve)
            existingScript.addEventListener("error", reject)
            return
        }

        const script = document.createElement("script")
        script.src = POWERBI_SDK_URL
        script.async = true
        script.onload = resolve
        script.onerror = reject
        document.body.appendChild(script)
    })
}

const GestaoSenai = () => {
    const containerRef = useRef(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState("")

    useEffect(() => {
        let isMounted = true

        const embedReport = async () => {
            try {
                const [{ data }] = await Promise.all([
                    api.http.get("/indicadores-gerais/gestao-senai/embed"),
                    loadPowerBiSdk(),
                ])

                if (!isMounted || !containerRef.current) {
                    return
                }

                const powerbi = window.powerbi
                const models = window["powerbi-client"].models

                powerbi.reset(containerRef.current)
                powerbi.embed(containerRef.current, {
                    type: data.type,
                    id: data.reportId,
                    embedUrl: data.embedUrl,
                    accessToken: data.accessToken,
                    tokenType: models.TokenType.Embed,
                    settings: {
                        panes: {
                            filters: { visible: false },
                            pageNavigation: { visible: true },
                        },
                    },
                })
            } catch (err) {
                if (isMounted) {
                    setError(err.toString())
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        embedReport()

        return () => {
            isMounted = false

            if (window.powerbi && containerRef.current) {
                window.powerbi.reset(containerRef.current)
            }
        }
    }, [])

    return (
        <Grid
            container direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: 600 }}
        >
            {loading && <CircularProgress />}
            {error && (
                <Typography color="error">
                    {error}
                </Typography>
            )}
            <div
                ref={containerRef}
                style={{
                    display: loading || error ? "none" : "block",
                    width: 1100,
                    height: 600,
                }}
            />
        </Grid>
    )
}
export default GestaoSenai
